// @flow
import React from 'react'
import { TextField, Grid } from '@material-ui/core'
import i18n from 'i18next'

type Props = { address: Object }

const AddressCard = (props: Props) => (
  <Grid item xs={12}>
    <Grid container spacing={16}>
      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.name')}
          value={props.address.name}
          margin='none'
          variant='outlined'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.city')}
          value={props.address.city}
          variant='outlined'
          margin='none'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.street')}
          value={props.address.street}
          margin='none'
          variant='outlined'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.number')}
          value={props.address.number}
          margin='none'
          variant='outlined'
          disabled
          fullWidth
        />
      </Grid>

      {props.address.details && (
        <Grid item xs={12} sm={4}>
          <TextField
            label={i18n.t('checkout.label.details')}
            value={props.address.details}
            margin='none'
            variant='outlined'
            disabled
            fullWidth
          />
        </Grid>
      )}

      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.postalCode')}
          value={props.address.postalCode}
          margin='none'
          variant='outlined'
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          label={i18n.t('checkout.label.phone')}
          value={props.address.phone}
          margin='none'
          variant='outlined'
          disabled
          fullWidth
        />
      </Grid>
    </Grid>
  </Grid>
)

export default AddressCard
